import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Accordion, Text } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect, withFlag } from "../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _FAQRow = function _FAQRow(_ref) {
  var label = _ref.label,
    content = _ref.content,
    onClick = _ref.onClick,
    isEnable = _ref.isEnable;
  return /*#__PURE__*/React.createElement(Accordion, {
    className: cn('accordion'),
    isOpen: isEnable,
    key: label,
    label: /*#__PURE__*/React.createElement(Text, {
      className: cn('accordion-title'),
      color: "primary",
      variant: "body-small"
    }, label),
    onClick: onClick,
    "data-t-id": "components-FAQRow"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('accordion-content'),
    color: "secondary",
    tagName: "div",
    variant: "body-small"
  }, content));
};
export var FAQRow = compose(enhancedConnect({
  label: PropTypes.string,
  content: PropTypes.string
}), withFlag, withAutoMetric.Element(function (props) {
  return {
    text: props.label,
    isOpen: String(props.isEnable)
  };
}))(_FAQRow);